<!-- Loading state -->
<ng-container *ngIf="isInitialLoading$ | async">
  <app-content-loader [blockCount]="5" [equalLines]="true"></app-content-loader>
</ng-container>

<!-- Main content -->
<form [formGroup]="form" *ngIf="!(isInitialLoading$ | async)">
  <div class="section-container">
    <div class="content-box">
      <!-- Header with toggle -->
      <div class="header">
        <div class="toggle-header">
          <h3 class="title">{{ 'Enable webhooks' | translate }}</h3>
          <p class="description">
            {{
              'Configure webhooks for your institution. Changes may take up to one hour to take effect.'
                | translate
            }}
          </p>
        </div>
        <div class="control-toggle">
          <mat-slide-toggle formControlName="enable" class="custom-mat-toggle"> </mat-slide-toggle>
        </div>
      </div>

      <!-- Form fields (shown when enabled) -->
      <ng-container *ngIf="form.get('enable')?.value">
        <hr class="divider" />

        <div class="form-fields">
          <!-- URL Field -->
          <div class="form-field">
            <label>
              <span class="label">{{ 'Webhook URL' | translate }}</span>
              <input
                type="text"
                formControlName="url"
                placeholder="https://..."
                [class.invalid]="form.get('url')?.invalid && form.get('url')?.touched"
              />
            </label>
            <span class="error" *ngIf="form.get('url')?.touched">
              <ng-container *ngIf="form.get('url')?.errors?.['required']">
                {{ 'This field is required.' | translate }}
              </ng-container>
              <ng-container *ngIf="form.get('url')?.errors?.['pattern']">
                {{ 'Invalid URL.' | translate }}
              </ng-container>
            </span>
          </div>

          <!-- Secret Field -->
          <div class="form-field">
            <label>
              <span class="label">{{ 'Webhook Secret Key' | translate }}</span>
              <input
                type="text"
                formControlName="secret"
                [class.invalid]="form.get('secret')?.invalid && form.get('secret')?.touched"
              />
            </label>
            <span
              class="error"
              *ngIf="(form.get('secret')?.errors?.['required'] || form.get('secret')?.errors?.['whitespace']) && form.get('secret')?.touched"
            >
              {{ 'Secret Key cannot be empty' | translate }}
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</form>
